import { Language } from "../../assets/languages/langs";

import { LOGIN_LANGUAGE_ORDER } from "./loginTexts";

const STORAGE_KEY = "dispatcher.loginLanguage";

const isLanguage = (value: unknown): value is Language =>
	typeof value === "string" &&
	LOGIN_LANGUAGE_ORDER.includes(value as Language);

/** First browser language we have (`uk-UA` -> `uk`), else English. */
export const detectLanguage = (preferred: readonly string[]): Language => {
	const found = preferred
		.map((tag) => tag.toLowerCase().split("-")[0])
		.find(isLanguage);
	return found ?? "en";
};

/** Language picked on the login screen or in the header, kept per browser. */
export const readStoredLanguage = (): Language | undefined => {
	try {
		const value = localStorage.getItem(STORAGE_KEY);
		return isLanguage(value) ? value : undefined;
	} catch {
		return undefined;
	}
};

export const storeLoginLanguage = (lang: Language): void => {
	try {
		localStorage.setItem(STORAGE_KEY, lang);
	} catch {
		// Private mode or blocked storage: the choice lives until reload.
	}
};

/** Stored choice, else the browser language, else English. */
export const getLoginLanguage = (): Language => {
	const stored = readStoredLanguage();
	if (stored) return stored;
	if (typeof navigator === "undefined") return "en";
	if (navigator.languages?.length) return detectLanguage(navigator.languages);
	return detectLanguage([navigator.language]);
};
